<template>
    <div>
        <confirm-dialog ref="confirm"></confirm-dialog>
        <prompt-dialog ref="prompt"></prompt-dialog>
        <alert-dialog ref="alert"></alert-dialog>
    </div>    
</template>

<script>

    import confirmDialog from './components/confirm-dialog.vue';
    import promptDialog from './components/prompt-dialog.vue';
    import alertDialog from './components/alert-dialog.vue';

    export default {
        name: 'App',
        components: {
            confirmDialog: confirmDialog,
            promptDialog: promptDialog,
            alertDialog: alertDialog
        },
        created: function () { },
        mounted: function () { },
        data: function () {
            return {};
        },
        methods: {
            message: function (message, title = '', type = 'primary', options = {}) {
                var default_options = {title: title, variant: type, appendToast: true, autoHideDelay:2000, noCloseButton:true};
                var settings = {...default_options, ...options};
                this.$bvToast.toast(message, settings);
            }
        }
    }
</script>

<style>
</style>
